<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m7.192 7.975 4.032-4.032a1.14 1.14 0 1 0-1.618-1.606l-4.829 4.83a1.139 1.139 0 0 0 0 1.616l4.83 4.887a1.138 1.138 0 0 0 .808.33 1.14 1.14 0 0 0 .809-.33 1.14 1.14 0 0 0 0-1.606l-4.032-4.09Z"
      fill="currentColor"
    />
  </svg>
</template>
